import { Component, Input } from '@angular/core';

import { Usuario } from '../../usuario';

@Component({
    selector: 'sgt-usuario-permissao-cliente',
    templateUrl: './usuario-permissao-cliente.component.html',
    styleUrls: ['./usuario-permissao-cliente.component.less']
})
export class UsuarioPermissaoClienteComponent {
    @Input() entity: Usuario;

    /** Verifica se possui alguma opção para selecionar */
    possuiAlgumaOpcao(): boolean {
        return true;
    }
}
